import { consumer, GameTime, inject } from "@spawn/core";
import { IBraggResponseFreegameEvent } from "@spawn/freegames";
import { INetworkState } from "@spawn/networking";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { FGSpinActionBragg } from "./fgSpinActionBragg";

@consumer
export class FGPseudoSpinActionBragg extends FGSpinActionBragg {
	@inject private readonly gameTime!: GameTime;

	public async execute(): Promise<INetworkState> {
		await this.gameTime.waitFor(0.2);
		const response = CacheStorage.get<IBraggResponseFreegameEvent>(CacheKeys.FirstFGSpinResponse);
		return this.parse(response, this.adapter);
	}
}
